var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNodata(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 171.671,
    height: 189.061,
    viewBox: "0 0 171.671 189.061",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2128",
    "data-name": "Group 2128",
    transform: "translate(-23.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2127",
    "data-name": "Group 2127",
    transform: "translate(23.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6355",
    "data-name": "Path 6355",
    d: "M196.314,206.073h-4.956l-30.6-30.6a38.318,38.318,0,1,0-12.8,12.8l30.6,30.6v4.956H107.148v-29.6H77.55V87.309H178.555v100.82h5.55V81.759h-88.8V69.55h91.94V64H89.759V81.759H72v116.4l31.224,31.224H184.1V218.877l7.254-7.254h10.505V87.494h-5.55ZM101.6,219.908,81.474,199.783H101.6Zm-6.29-64.338a32.743,32.743,0,1,1,32.743,32.743A32.78,32.78,0,0,1,95.309,155.57Zm62.172,24.473,5.125,5.125-4.956,4.956L152.525,185A38.661,38.661,0,0,0,157.481,180.044ZM181.33,213.8l-19.755-19.755,4.956-4.956,19.755,19.755Z",
    transform: "translate(-54.056 -40.321)",
    fill: "#1b9fdc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6356",
    "data-name": "Path 6356",
    d: "M178.454,240a26.454,26.454,0,1,0,26.454,26.454A26.484,26.484,0,0,0,178.454,240Zm0,47.358a20.9,20.9,0,1,1,20.9-20.9A20.928,20.928,0,0,1,178.454,287.358Z",
    transform: "translate(-104.457 -151.204)",
    fill: "#1b9fdc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6357",
    "data-name": "Path 6357",
    d: "M209.1,272.009a8.642,8.642,0,0,0-6.412,2.4,8.735,8.735,0,0,0-2.69,6.288h5.55a3.145,3.145,0,0,1,3.3-3.141,3.2,3.2,0,0,1,2.989,2.989,3.147,3.147,0,0,1-1.3,2.7,11.43,11.43,0,0,0-4.614,9.288h5.55a5.872,5.872,0,0,1,2.316-4.791,8.7,8.7,0,0,0-4.684-15.734Z",
    transform: "translate(-134.698 -171.365)",
    fill: "#1b9fdc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6358",
    "data-name": "Path 6358",
    d: "M216,335.5h5.55v5.92H216Z",
    transform: "translate(-144.779 -211.371)",
    fill: "#1b9fdc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6359",
    "data-name": "Path 6359",
    d: "M183.5,168h5.92v5.55H183.5Z",
    transform: "translate(-124.303 -105.843)",
    fill: "#1b9fdc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6360",
    "data-name": "Path 6360",
    d: "M215.5,168h5.92v5.55H215.5Z",
    transform: "translate(-144.464 -105.843)",
    fill: "#1b9fdc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6361",
    "data-name": "Path 6361",
    d: "M247.5,168h5.92v5.55H247.5Z",
    transform: "translate(-164.624 -105.843)",
    fill: "#1b9fdc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6362",
    "data-name": "Path 6362",
    d: "M104.695,17.389A8.695,8.695,0,1,0,96,8.695,8.7,8.7,0,0,0,104.695,17.389Zm0-11.839a3.145,3.145,0,1,1-3.145,3.145A3.148,3.148,0,0,1,104.695,5.55Z",
    transform: "translate(-69.176)",
    fill: "#1b9fdc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6363",
    "data-name": "Path 6363",
    d: "M400.695,64a8.695,8.695,0,1,0,8.695,8.695A8.7,8.7,0,0,0,400.695,64Zm0,11.839a3.145,3.145,0,1,1,3.145-3.145A3.148,3.148,0,0,1,400.695,75.839Z",
    transform: "translate(-255.662 -40.321)",
    fill: "#1b9fdc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6364",
    "data-name": "Path 6364",
    d: "M35.154,55.5H29.6v6.1H23.5v5.55h6.1v6.1h5.55v-6.1h6.1V61.6h-6.1Z",
    transform: "translate(-23.5 -34.966)",
    fill: "#1b9fdc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6365",
    "data-name": "Path 6365",
    d: "M457.259,141.6h-6.1v-6.1H445.6v6.1h-6.1v5.55h6.1v6.1h5.55v-6.1h6.1Z",
    transform: "translate(-285.588 -85.367)",
    fill: "#1b9fdc"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNodata);
export default __webpack_public_path__ + "static/media/nodata.d9b8562de5d816c07f947b2e1414af14.svg";
export { ForwardRef as ReactComponent };